/* ─────────────────────────────────────────────────────────────────────────────
   GrowthOS migration — HubSpot Review — RTK Query slice. The audit (companies +
   open-deal hygiene with its deal drill lists) plus, per enrichment-gap tile,
   the companies behind it (fetched on click — the lists can run to ~24k rows).
   ──────────────────────────────────────────────────────────────────────────── */
import { createApi } from '@reduxjs/toolkit/query/react'
import { apiConstants, get } from '../common/constants'

const HUBSPOT_REVIEW = apiConstants.GROWTHOS_ADMIN_HUBSPOT_REVIEW

const run = async (promise) => {
  try {
    const res = await promise
    return { data: res?.data }
  } catch (err) {
    const r = err?.response
    return {
      error: {
        status: r?.status,
        data: r?.data,
        message: r?.data?.message || err.message,
      },
    }
  }
}

export const growthosHubspotReviewApiSlice = createApi({
  reducerPath: 'growthosHubspotReviewApi',
  baseQuery: () => ({ data: undefined }),
  tagTypes: ['HubspotReview'],
  endpoints: (b) => ({
    getHubspotReview: b.query({
      queryFn: () => run(get(HUBSPOT_REVIEW)),
      providesTags: ['HubspotReview'],
    }),
    getHubspotCompanyGap: b.query({
      queryFn: (gap) => run(get(`${HUBSPOT_REVIEW}/company-gaps`, { gap })),
      providesTags: ['HubspotReview'],
    }),
  }),
})

export const { useGetHubspotReviewQuery, useGetHubspotCompanyGapQuery } = growthosHubspotReviewApiSlice
